import { GWidget } from "./GWidget";
import { Tween } from "../tween/Tween";
import { ProgressTitleType } from "./Const";
import { ILaya } from "../../ILaya";
import { MathUtil } from "../maths/MathUtil";
import { NodeFlags } from "../Const";
import { ProgressMesh } from "../display/mesh/ProgressMesh";
export class GProgressBar extends GWidget {
    constructor() {
        super();
        this._min = 0;
        this._max = 0;
        this._value = 0;
        this._titleType = 0;
        this._reverse = false;
        this._barMaxWidthDelta = 0;
        this._barMaxHeightDelta = 0;
        this._barStartX = 0;
        this._barStartY = 0;
        this._value = 50;
        this._max = 100;
    }
    get titleType() {
        return this._titleType;
    }
    set titleType(value) {
        if (this._titleType != value) {
            this._titleType = value;
            this.update(null, true);
        }
    }
    get min() {
        return this._min;
    }
    set min(value) {
        if (this._min != value) {
            this._min = value;
            this.update(null, true);
        }
    }
    get max() {
        return this._max;
    }
    set max(value) {
        if (this._max != value) {
            this._max = value;
            this.update(null, true);
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value != value) {
            if (this._tween) {
                this._tween.kill();
                this._tween = null;
            }
            this._value = value;
            this.update(null, true);
        }
    }
    get hBar() {
        return this._hBar;
    }
    set hBar(value) {
        this._hBar = value;
        this._value = this._max;
        this._barStartX = 0;
        this.update(null, false);
    }
    get vBar() {
        return this._vBar;
    }
    set vBar(value) {
        this._vBar = value;
        this._value = this._max;
        this._barStartY = 0;
        this.update(null, false);
    }
    get titleWidget() {
        return this._titleWidget;
    }
    set titleWidget(value) {
        this._titleWidget = value;
        this.update(null, false);
    }
    get reverse() {
        return this._reverse;
    }
    set reverse(value) {
        this._reverse = value;
        this.update(null, false);
    }
    tweenValue(value, duration) {
        let oldValule;
        if (this._tween) {
            let tweener = this._tween.findTweener("progress");
            if (tweener)
                oldValule = tweener.value.get(null);
            else
                oldValule = this._value;
            tweener.kill();
        }
        else
            oldValule = this._value;
        this._value = value;
        return Tween.create(this).name("progress").go(null, oldValule, this._value).duration(duration).ease("linear")
            .onUpdate(tweener => this.update(tweener.value.get(null)));
    }
    update(newValue, delay) {
        if (this._getBit(NodeFlags.EDITING_ROOT_NODE)) {
            this.updateTitle(this._max, this._max, 1);
            return;
        }
        if (newValue == null && delay === true) {
            ILaya.timer.callLater(this, this.update);
            return;
        }
        if (newValue == null)
            newValue = this._value;
        let percent = MathUtil.clamp01((newValue - this._min) / (this._max - this._min));
        this.updateTitle(newValue, this._max, percent);
        let fullWidth = this.width - this._barMaxWidthDelta;
        let fullHeight = this.height - this._barMaxHeightDelta;
        if (!this._reverse) {
            if (this._hBar) {
                if (!this.setFillAmount(this._hBar, percent))
                    this._hBar.width = Math.round(fullWidth * percent);
            }
            if (this._vBar) {
                if (!this.setFillAmount(this._vBar, percent))
                    this._vBar.height = Math.round(fullHeight * percent);
            }
        }
        else {
            if (this._hBar) {
                if (!this.setFillAmount(this._hBar, 1 - percent)) {
                    this._hBar.width = Math.round(fullWidth * percent);
                    this._hBar.x = this._barStartX + (fullWidth - this._hBar.width);
                }
            }
            if (this._vBar) {
                if (!this.setFillAmount(this._vBar, 1 - percent)) {
                    this._vBar.height = Math.round(fullHeight * percent);
                    this._vBar.y = this._barStartY + (fullHeight - this._vBar.height);
                }
            }
        }
    }
    updateTitle(value, max, percent) {
        let obj = this._titleWidget;
        if (!obj)
            return;
        switch (this._titleType) {
            case ProgressTitleType.Percent:
                obj.text = Math.floor(percent * 100) + "%";
                break;
            case ProgressTitleType.ValueAndMax:
                obj.text = Math.floor(value) + "/" + Math.floor(max);
                break;
            case ProgressTitleType.Value:
                obj.text = "" + Math.floor(value);
                break;
            case ProgressTitleType.Max:
                obj.text = "" + Math.floor(max);
                break;
        }
    }
    setFillAmount(bar, amount) {
        let mesh = bar.mesh;
        if (mesh instanceof ProgressMesh) {
            mesh.amount = amount;
            bar.graphics.repaint();
            return true;
        }
        else
            return false;
    }
    _onConstruct(inPrefab) {
        if (this._hBar) {
            this._barMaxWidthDelta = this.width - this._hBar.width;
            this._barStartX = this._hBar.x;
        }
        if (this._vBar) {
            this._barMaxHeightDelta = this.height - this._vBar.height;
            this._barStartY = this._vBar.y;
        }
        ILaya.timer.runCallLater(this, this.update, true);
        super._onConstruct(inPrefab);
    }
    _sizeChanged() {
        super._sizeChanged();
        this.update(null, true);
    }
}
